<!--  -->
<template>
  <div>
    <el-form label-position="right" label-width="10px" :model="formLabelAlign">
      <el-form-item>
        <div style="display: flex;align-items: center;justify-content: space-around;">
          <div style="display: flex;align-items: center;">
            <div>预计拉群：</div>
            <el-tag>{{ formLabelAlign.expect_chat_num }}</el-tag>
          </div>
          <div style="display: flex;align-items: center;">
            <div>实际拉群：</div>
            <el-tag>{{ formLabelAlign.actual_chat_num }}</el-tag>
          </div>
        </div>
      </el-form-item>
      <el-form-item>
        <div style="display: flex;align-items: center;justify-content: space-around;">
          <div style="display: flex;align-items: center;">
            <div>预计拉人：</div>
            <el-tag>{{ formLabelAlign.expect_invite_num }}</el-tag>
          </div>
          <div style="display: flex;align-items: center;">
            <div>实际拉人：</div>
            <el-tag>{{ formLabelAlign.actual_invite_num }}</el-tag>
          </div>
        </div>
      </el-form-item>
      <!-- <el-form-item label="预计拉人">
        <el-tag>{{ formLabelAlign.expect_invite_num }}</el-tag>
      </el-form-item>
      <el-form-item label="实际拉人">
        <el-tag>{{ formLabelAlign.actual_invite_num }}</el-tag>
      </el-form-item> -->
    </el-form></div>
</template>

<script>
import { schedulelist } from '@/api/officialaccount.js'
export default {
  components: {},
  data() {
    return {
      chat_set_id: null,
      formLabelAlign: {}
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(chat_set_id) {
      console.log('chat_set_id', chat_set_id)
      this.chat_set_id = chat_set_id
      this.list()
    },
    async list() {
      const data = await schedulelist({
        chat_set_id: this.chat_set_id
      })
      this.formLabelAlign = data.data
      console.log('data', data)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
